import { render, staticRenderFns } from "./UploadedFileItem.vue?vue&type=template&id=315544f1&scoped=true&"
import script from "./UploadedFileItem.vue?vue&type=script&lang=js&"
export * from "./UploadedFileItem.vue?vue&type=script&lang=js&"
import style0 from "./UploadedFileItem.vue?vue&type=style&index=0&id=315544f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315544f1",
  null
  
)

export default component.exports